module.exports = __webpack_public_path__ + "icon-calendar.png?544a1ea200919ac85a70272f14a00265";